const toCurrency = (_value, withoutCurrencySymbol = false, fixed = 2) => {
  const value = parseFloat(_value || 0);
  const output = new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: fixed,
  }).format(value);

  return withoutCurrencySymbol ? output.replace('$', '') : output;
};

export default toCurrency;
